import { gql } from '@apollo/client';
import { MISSION_LOCKED_REASONS, MISSION_REWARDS } from './missionSubFragments';

export const MISSION_STATUS = gql`
  fragment MissionsStatus on Mission {
    __typename
    id
    completed
    expiringDate
    expiringSoon
    inProgress
    repeats

    ...MissionLockedReasons
  }

  ${MISSION_LOCKED_REASONS}
`;

export const MISSION_BASICS = gql`
  fragment MissionBasics on Mission {
    __typename
    id
    name
    description
    iconImageUrl
    startDate
    endDate
    iLike
    totalLikes
    ...MissionRewards
  }

  ${MISSION_REWARDS}
`;
